module.exports = __webpack_public_path__ + "assets/img/23_196_big.8bc75d1a.jpg";